export default {
    id: 'ID',
    provider: 'Anbieter',
    client_id: 'Client ID',
    client_secret: 'Client Secret',
    redirect: 'URL',
    created_at: 'Erstellt am'
}
